import { Component, Input, OnInit } from '@angular/core';
import { LivreurUberService } from '../livreur-uber.service';

@Component({
  selector: 'app-gateaux',
  templateUrl: './gateaux.component.html',
  styleUrls: ['./gateaux.component.css']
})
export class GateauxComponent implements OnInit {
  leRayonnage = [
    {
      nom : 'pain au chocolat',
      image : 'https://www.recipetineats.com/wp-content/uploads/2020/03/Brownies_0-SQ.jpg',
      description : 'c\'est un gateau au chocolat moelleux',
      gout : 'sucré',
      tempsPreparation : 25,
      calories : 380,
      mangeOuNon : true,
      prix : 15
    },
    
    {
      nom : 'Cake aux Olives',
      image : 'https://odelices.ouest-france.fr/images/recettes/cake-olive-parmesan.jpg',
      description : 'C\'est un cake avec des olives dedans',
      gout : 'sale',
      tempsPreparation : 15,
      calories : 700,
      mangeOuNon : true,
      prix : 10
    },
    {
      nom : 'Tarte aux Pommes',
      image : 'https://www.cuisineetsentiments.com/images/recette-tarte-aux-pommes_3.jpg',
      description : 'Une tarte avec des pommes dessus',
      gout : 'sucré',
      tempsPreparation : 40,
      calories : 780,
      mangeOuNon : false,
      prix : 23
    },

    {
      nom : 'Quiche Lorraine',
      image : 'https://assets.afcdn.com/recipe/20110831/30274_w600.jpg',
      description : 'Une quiche avec de la creme et des lardons',
      gout : 'salé',
      tempsPreparation : 50,
      calories : 600,
      mangeOuNon : false,
      prix : 8.6515468
    }

  
];

lePanier = Array();

ajouterUnGateauAuPanier(quelGateau: Object) {
  this.lePanier.push(quelGateau);

  }


    

  constructor(private monService : LivreurUberService) { }

  ngOnInit(): void {
    this.lePanier = this.monService.livrerLacommande();
    this.monService.allerChercherLaCommande(this.lePanier);
   
  }


}
